import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const Basketball = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Basketball ',
    category: 'Team Sports',
    description: 'Competitive basketball league with regular tournaments.',
    longDescription: 'Join our dynamic Basketball Club for exciting games and professional training. With full-court facilities, experienced coaches, and multiple leagues for different age groups and skill levels, we offer the perfect environment to develop your game. From youth development to adult competitive leagues, there\'s a place for everyone.',
    images: [
      getImagePath('images/bars/basketball.jpg'),
      getImagePath('images/bars/basketball.jpg'),
      getImagePath('images/bars/basketball.jpg')
    ],
    icon: 'fa-basketball-ball',
    members: '56+ active members',
    coach: 'Coach Michael Johnson (Ex-Pro Player)',
    schedule: 'Tue, Thu: 7pm | Sat: 2pm',
    level: 'All Levels',
    features: [
      'Full Court Facilities',
      'Professional Coaching',
      'Youth Development Program',
      'Men\'s League',
      'Women\'s League',
      'Weekend Tournaments',
      'Skills Clinics',
      'Summer Camps'
    ],
    facilities: ['Indoor Court', 'Scoreboard', 'Locker Rooms', 'Spectator Seating'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'basketball@nlngraclub.com',
      extension: '204'
    },
    leagues: ['Youth League (U14, U16, U18)', 'Men\'s Open', 'Women\'s Open', 'Recreational'],
    achievements: ['City Champions 2023', 'Youth Tournament Winners 2022']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Head Coach</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Schedule</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Leagues:</span>
                  <span className="info-value">{sectionData.leagues.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Achievements:</span>
                  <span className="info-value">{sectionData.achievements.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Tryouts
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Basketball;